import { computed } from "vue";

import { ApplicationPriority } from "./types";

export function useValidations(hasPriorities: boolean) {
  const rules = computed(() => {
    const innerRules = [];

    type Priorities = [
      ApplicationPriority | undefined,
      ApplicationPriority | undefined,
      ApplicationPriority | undefined,
    ];

    if (hasPriorities) {
      innerRules.push([
        "priorities",
        [
          (val: Priorities) =>
            (!val.includes(null) && !val.includes(undefined)) || "required",
        ],
      ]);
    }

    return Object.fromEntries(innerRules);
  });

  return { rules };
}
